import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  ConfirmBatchPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";
import { ConfirmBatchPaymentParam } from "features/stock-ordering/core/stock-ordering.params";

export enum ConfirmBatchPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: ConfirmBatchPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: ConfirmBatchPaymentState.initial,
  message: "",
};

export const confirmBatchPayment = createAsyncThunk(
  "confirmBatchPayment",
  async (param: ConfirmBatchPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await ConfirmBatchPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const confirmBatchPaymentSlice = createSlice({
  name: "confirmBatchPayment",
  initialState,
  reducers: {
    resetConfirmBatchPayment: (state) => {
      state.status = ConfirmBatchPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmBatchPayment.pending, (state) => {
        state.status = ConfirmBatchPaymentState.inProgress;
      })
      .addCase(confirmBatchPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = ConfirmBatchPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(confirmBatchPayment.rejected, (state, action) => {
        state.status = ConfirmBatchPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectConfirmBatchPayment = (state: RootState) =>
  state.confirmBatchPayment;
export const { resetConfirmBatchPayment } = confirmBatchPaymentSlice.actions;
export default confirmBatchPaymentSlice.reducer;
